import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '@usucampeao/utils-frontend';
import { CadastroResumoPagamentoComponent } from './cadastro-resumo-pagamento.component';

@NgModule({
  declarations: [CadastroResumoPagamentoComponent],
  imports: [
    // root
    CommonModule,
    IonicModule,

    // others
    PipesModule,
  ],
  exports: [CadastroResumoPagamentoComponent],
})
export class CadastroResumoPagamentoModule { }
